@if (!to.hideControl) {
  @if (props.readonly) {
    <new-ui-wrapper-readonly
      [label]="props.label"
      [value]="formControl.value | staticData: StaticDataType.Profession | async"
      [suggested]="formControl | isSuggested | async"
    />
  } @else {
    <div [class]="'col' + (!props.readonly && props.editFieldStyleClass ? ' ' + props.editFieldStyleClass : '')">
      <new-ui-profession-selector
        [formControl]="$any(formControl)"
        [formlyAttributes]="field"
        [filledByAI]="formControl | isFilledByAI | async"
        [multi]="props.multi"
        [all]="props.all"
        [profession]="props.profession"
        [language]="props.language"
        [candidateOrganizationId]="formState.organizationId"
        [label]="props.label"
        [required]="props.required"
        [showClear]="props.showClear"
        [dt]="props.dt"
      />

      @if (!props.readonly && props.hint) {
        <p-message [dt]="props.dt?.components?.message" severity="info" variant="simple" size="small">
          {{ props.hint }}
        </p-message>
      }

      @if (showError) {
        <p-message [dt]="props.dt?.components?.message" severity="error" variant="simple" size="small">
          <formly-validation-message [field]="field" />
        </p-message>
      }
    </div>
  }
}
